export default function VideoHub() {
  const videos = [
    {
      title: 'Oceans',
      duration: '30 min',
      mood: 'Deep Calm'
    },
    {
      title: 'Africa',
      duration: '44 min',
      mood: 'Relaxation'
    },
    {
      title: 'Mountains',
      duration: '45 min',
      mood: 'Mindful Breaks'
    },
    {
      title: 'Night Skies',
      duration: '18 min',
      mood: 'Anxiety Relief'
    },
   
  ];

  return (
    <section id="video" className="py-24 bg-gradient-to-b from-[#F0F4F8] to-[#E8F1F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif text-[#2F7FB7] mb-6">Video Hub</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-6">
            Your peaceful corner to pause, breathe, and let calming visuals gently settle your mind and body.
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Here you'll find tranquil nature scenes — flowing rivers, quiet forests, rainfall, ocean horizons, sunlight through trees — all paired with soothing, nature-inspired music to create a deeply immersive, comforting experience.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <div 
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden bg-gradient-to-br from-[#E8F1F5] to-[#2F7FB7]/20">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-3xl text-[#2F7FB7] ml-1"></i>
                  </div>
                </div>
                <span className="absolute top-4 right-4 bg-black/60 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full whitespace-nowrap">
                  {video.duration}
                </span>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-serif text-[#2F7FB7] mb-2 group-hover:text-[#1E5A8E] transition-colors">
                  {video.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">{video.mood}</p>
                <a href="/download" className="text-[#2F7FB7] font-medium inline-flex items-center gap-2 group-hover:gap-3 transition-all text-sm whitespace-nowrap cursor-pointer">
                  Watch Now
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a href="/download" className="bg-[#2F7FB7] text-white px-8 py-4 rounded-full font-medium hover:bg-[#1E5A8E] transition-all hover:shadow-xl inline-flex items-center gap-3 cursor-pointer whitespace-nowrap group">
            Explore All Videos
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        <div className="mt-16 bg-gradient-to-br from-[#2F7FB7] to-[#1E5A8E] rounded-3xl p-10 text-white">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-serif mb-4">Ideal For</h3>
              <ul className="space-y-3 text-white/90">
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-2xl"></i>
                  <span>Anxiety relief and emotional regulation</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-2xl"></i>
                  <span>Sleep preparation and wind-down routines</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-2xl"></i>
                  <span>Mindful breaks during busy days</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-check-line text-2xl"></i>
                  <span>Moments of visual calm and grounding</span>
                </li>
              </ul>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="text-4xl font-serif mb-2">300+</div>
                <div className="text-sm text-white/80">Nature Scenes</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="text-4xl font-serif mb-2">HD</div>
                <div className="text-sm text-white/80">Quality</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center">
                <div className="text-4xl font-serif mb-2">New</div>
                <div className="text-sm text-white/80">Weekly</div>
              </div>
            </div>
          </div>
        </div>
            
      </div>
    </section>
  );
}
